// extracted by mini-css-extract-plugin
export default {"formTitle":"_93bb89cbb59bcfe77d7ec74475d59369"};